<template>
    <v-dialog v-model="dialog" max-width="430" :fullscreen="$vuetify.breakpoint.xs">
        <v-card class="py-8 px-11">
            <h2 class="text-center">Are you sure?</h2>
            <p class="text-center font-weight-bold mt-3">If you delete this quiz will be removed all related data etc...</p>
            <v-card-actions class="d-flex justify-center">
                <v-btn class="green white--text mr-4" type="submit" :loading="loadingRequest" @click="deleteQuiz">Agree</v-btn>
                <v-btn class="transparent green--text ml-4" @click="dialog = false">Disagree</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
    export default {
        props: ['quiz_id'],
        data(){
            return {
                dialog: false,
                loadingRequest: false,
            }
        },

        methods: {
            deleteQuiz() {
                this.loadingRequest = true;
                this.$apiAdmin('quizzes').delete(this.quiz_id)
                    .then(() => {
                        this.$parent.$emit('getQuizzes');
                        this.$store.dispatch('alert', {type: 1, message: 'Successfully deleted.'});
                    }).finally(() => {
                    this.loadingRequest = false;
                    this.dialog = false;
                })
            }
        }
    }
</script>

<style scoped lang="scss">
    @import "../../../scss/components/dialog";
</style>